/* eslint-disable import/prefer-default-export */
import { schema } from 'normalizr';

const rolesSchema = [new schema.Entity('roles')];

export {
  rolesSchema,
};
